import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, UrlTree } from '@angular/router';
import { PlatformAccessService } from './platform-access.service';
import { OAuthService } from '../oauth.service';

/**
 * Runs BEFORE AuthGuard on protected routes so the platform-access check happens
 * before getCurrentUser()/any app data call (spec FR-017). The /unauthorized route
 * is NOT wired with this guard, which prevents redirect loops (FR-009).
 */
@Injectable({ providedIn: 'root' })
export class PlatformAccessGuard implements CanActivate, CanActivateChild {
  constructor(
    private access: PlatformAccessService,
    private oauth: OAuthService,
    private router: Router,
  ) {}

  canActivate(): Promise<boolean | UrlTree> {
    return this.check();
  }

  canActivateChild(): Promise<boolean | UrlTree> {
    return this.check();
  }

  private async check(): Promise<boolean | UrlTree> {
    // FR-006 / US5: skip entirely when Keycloak is not configured
    if (!this.access.isConfigured()) {
      return true;
    }
    // FR-005: never check when not authenticated — let AuthGuard redirect to login
    if (!this.oauth.isSignedIn()) {
      return true;
    }
    try {
      const allowed = await this.access.ensureAccessAllowed();
      return allowed ? true : this.router.parseUrl('/unauthorized');
    } catch {
      // FR-004: fail closed
      return this.router.parseUrl('/unauthorized');
    }
  }
}
